import { createAction } from 'typesafe-actions';

export type OddsUnit = 'decimal' | 'fraction' | 'american';

/** Used for testing */
export const dummyAction = createAction('betting/dummy')();

export const setOddsUnit = createAction('betting/set_odds_unit')<OddsUnit>();
